import { BreachPathDetailsMetadataSideMenuDataType } from '../types';

export function resourceNameRenderer(data: BreachPathDetailsMetadataSideMenuDataType): string {
  return data.name || '-';
}
